import React, { FunctionComponent } from 'react'
import { GetWidth } from 'utils/windowsSize'
import { Container } from './float-container.styles'

export const FloatContainer: FunctionComponent<any> = ({
  headerComposition,
  content
}) => {
  return (
    <Container className="sisu-float-container">
      <div className="wrapper-header">{headerComposition}</div>

      {content}
    </Container>
  )
}
